module.exports = __webpack_public_path__ + "img/illu-bee.2f285b1a.svg";